export default __webpack_public_path__ + "static/media/circuit-board.2b2f5c2a.png";